import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Layout, Row } from 'antd';
import Link from 'antd/lib/typography/Link';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { RootState } from '../../modules';
import {
  EnterpriseType1,
  getLoggedInUserAsync,
  logoutUserAsync,
} from '../../modules/auth';
import { defineAbilityFor } from '../../util/appAbilityService';

const StyledDiv = styled(Layout)`
  .pageDropdown {
    background: #fff;
  }
  .userMenu {
    margin-right: 30px;
  }

  .serviceMenu {
    margin-right: 30px;
    margin-left: 30px;
  }

  .userMenu:hover {
    color: #4b74ff;
  }

  .ant-menu > .ant-menu-item:hover,
  .ant-menu > .ant-menu-submenu:hover,
  .ant-menu > .ant-menu-item-active,
  .ant-menu > .ant-menu-submenu-active,
  .ant-menu > .ant-menu-item-open,
  .ant-menu > .ant-menu-submenu-open,
  .ant-menu > .ant-menu-item-selected,
  .ant-menu > .ant-menu-submenu-selected,
  .ant-menu > .ant-menu-submenu-selected:hover {
    color: red;
    border-bottom: 2px solid red;
  }

  li > .ant-dropdown-menu-title-content > a::after {
    color: #4b74ff;
    background-color: yellow;
  }

  .ant-dropdown-menu-title-content:hover > a {
    /* color: #4b74ff;
    background-color: green; */
    border-bottom-color: #4a235a;
  }

  .ant-dropdown-menu-item:hover {
    color: #4b74ff;
    background-color: green;
    /* border-bottom-color: #4a235a; */
  }

  .ant-menu-item-selected:hover {
    border-bottom-color: #4a235a;
  }

  //  Set menu style
  .ant-menu,
  .ant-menu-sub,
  .ant-menu-inline {
    color: white;
    background-color: #044d50 !important;
  }
  //  Set the submenu expansion style
  .ant-menu-submenu > .ant-menu {
    background-color: rgb(16, 71, 83) !important;
  }
  .ant-menu-submenu-title {
    color: green !important;
  }
  //  Remove the right border
  .ant-menu-inline {
    border: none;
  }
  //  Set up  a  Link style
  .ant-menu-item a {
    color: white !important;
  }
  .ant-menu-item a:hover {
    color: #044d50 !important;
  }
  //  Drop down arrow style
  .ant-menu-submenu-arrow {
    color: white;
  }
  // //  Set submenu style
  // .ant-menu-submenu-active {
  //   background-color: #fff !important;
  //   color: #044d50 !important;
  // }

  //  Select menu status
  .ant-menu-item-selected {
    background-color: rgb(4, 77, 92) !important;
    color: white !important;
  }
  //  Set unselected menu item mouse over style
  .ant-menu-item-active {
    background-color: #fff !important;
    color: #666666 !important;
  }

  .ant-select-dropdown-menu-item:not(
      .ant-select-dropdown-menu-item-disabled
    ):hover {
    background-color: red !important;
  }

  .ant-select-dropdown-menu-item-active {
    background-color: pink !important;
  }
`;

function PageDropdown() {
  const [mount, setMount] = useState(true);
  let history = useHistory();
  const [ability, setAbility] = useState<any>();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.auth.data);
  // const [isHidden, setIsHidden] = useState(false);
  const isHidden: boolean = false;

  useEffect(() => {
    if (!mount) return;
    if (user === null) {
      dispatch(getLoggedInUserAsync.request(null));
    } else {
      setAbility(defineAbilityFor(user));
    }
    return () => setMount(false);
  }, [user, dispatch, mount]);

  // const userMenu = (
  //   <Menu data-test="main-header-menu">
  //     {!user && (
  //       <Menu.Item key="login">
  //         <a href="/#" onClick={(e) => loginWithRedirect(e)}>
  //           로그인
  //         </a>
  //       </Menu.Item>
  //     )}
  //     <Menu.Item key="profile">
  //       <a href="/#" onClick={(e) => moveToProfilePage(e)}>
  //         내 계정
  //       </a>
  //     </Menu.Item>
  //     <Menu.Item key="approvals" hidden={isHidden}>
  //       <a href="/#" onClick={(e) => moveToMyEnterpriseDetailPage(e)}>
  //         내 회사
  //       </a>
  //     </Menu.Item>
  //     {user && (
  //       <Menu.Item key="logout">
  //         <a href="/#" onClick={(e) => logoutWithRedirect(e)}>
  //           로그아웃
  //         </a>
  //       </Menu.Item>
  //     )}
  //   </Menu>
  // );

  const userMenuItems = [];

  if (!user)
    userMenuItems.push({
      label: (
        <a href="/#" onClick={(e) => loginWithRedirect(e)}>
          로그인
        </a>
      ),
      key: 'login',
    });

  userMenuItems.push({
    label: (
      <a href="/#" onClick={(e) => moveToProfilePage(e)}>
        내 계정
      </a>
    ),
    key: 'profile',
  });

  userMenuItems.push({
    label: (
      <a href="/#" onClick={(e) => moveToMyEnterpriseDetailPage(e)}>
        내 회사
      </a>
    ),
    key: 'my-enterprise',
    hidden: isHidden,
  });

  if (user)
    userMenuItems.push({
      label: (
        <a href="/#" onClick={(e) => logoutWithRedirect(e)}>
          로그아웃
        </a>
      ),
      key: 'logout',
    });

  // const serviceMenu = (
  //   <Menu data-test="main-header-menu">
  //     <Menu.Item key="vendors">
  //       <a href="/#" onClick={(e) => moveToVendorsPage(e)}>
  //         거래처관리
  //       </a>
  //     </Menu.Item>
  //     {user?.myEnterprise.type1 === EnterpriseType1.CONTRACTOR && (
  //       <Menu.Item key="projectList">
  //         <a href="/#" onClick={(e) => moveToProjectListPage(e)}>
  //           공사관리
  //         </a>
  //       </Menu.Item>
  //     )}
  //     {!!ability && ability.can('update', 'EnterpriseRole') && (
  //       <Menu.Item key="expenses">
  //         <a href="/#" onClick={(e) => moveToExpensesPage(e)}>
  //           지출관리(관리자)
  //         </a>
  //       </Menu.Item>
  //     )}
  //   </Menu>
  // );

  const serviceMenuItems = [
    {
      label: (
        <a href="/#" onClick={(e) => moveToVendorsPage(e)}>
          거래처관리
        </a>
      ),
      key: 'vendors',
    },
  ];

  if (user?.myEnterprise.type1 === EnterpriseType1.CONTRACTOR)
    serviceMenuItems.push({
      label: (
        <a href="/#" onClick={(e) => moveToProjectListPage(e)}>
          공사관리
        </a>
      ),
      key: 'projects',
    });

  if (!!ability && ability.can('update', 'EnterpriseRole'))
    serviceMenuItems.push({
      label: (
        <a href="/#" onClick={(e) => moveToExpensesPage(e)}>
          비용관리(관리자)
        </a>
      ),
      key: 'expenses',
    });

  // const userGuideMenu = (
  //   <Menu>
  //     <Menu.Item key="user-guide-1">
  //       <Link
  //         href="https://quasar-beat-84a.notion.site/0d71785e9b724b869691b15e3138835f"
  //         target="_blank"
  //       >
  //         사용자 가이드
  //       </Link>
  //     </Menu.Item>
  //   </Menu>
  // );

  const userGuideMenuItems = [
    {
      label: (
        <Link
          href="https://quasar-beat-84a.notion.site/0d71785e9b724b869691b15e3138835f"
          target="_blank"
        >
          사용자 가이드
        </Link>
      ),
      key: 'user-guide-1',
    },
  ];

  const loginWithRedirect = (e: any) => {
    e.preventDefault();
    history.push('/login');
  };

  const logoutWithRedirect = (e: any) => {
    e.preventDefault();
    dispatch(logoutUserAsync.request(null, null));
    localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, '');
    history.push('/login');
  };

  const moveToProfilePage = (e: any) => {
    e.preventDefault();
    history.push(`/enterprises/${user?.myEnterprise.id}/profile`);
  };

  const moveToMyEnterpriseDetailPage = (e: any) => {
    e.preventDefault();
    history.push(`/enterprises/${user?.myEnterprise.id}/myEnterprise?tab=1`);
  };

  // const moveToMyEnterpriseSelectPage = (e: any) => {
  //   e.preventDefault();
  //   history.push(`/enterprises`);
  // };

  const moveToProjectListPage = (e: any) => {
    e.preventDefault();
    history.push(`/enterprises/${user?.myEnterprise.id}/main`);
    // window.location.reload();
  };

  // const moveToPartnersPage = (e: any) => {
  //   e.preventDefault();
  //   history.push(`/enterprises/${user?.myEnterprise.id}/partnerManagement`);
  // };

  // const moveToBidChancesPage = (e: any) => {
  //   e.preventDefault();
  //   history.push(`/enterprises/${user?.myEnterprise.id}/bidChances`);
  // };

  const moveToVendorsPage = (e: any) => {
    e.preventDefault();
    history.push(`/enterprises/${user?.myEnterprise.id}/vendors`);
  };

  const moveToExpensesPage = (e: any) => {
    e.preventDefault();
    history.push(`/enterprises/${user?.myEnterprise.id}/expenses`);
  };

  // const moveToVendorListPage = (e: any) => {
  //   e.preventDefault();
  //   history.push(`/enterprises/${user.myEnterprise.id}/vendors`);
  // };

  // const moveToMyApprovalManagementPage = (e: any) => {
  //   e.preventDefault();
  //   history.push(`/enterprises/${user?.myEnterprise.id}/approvals`);
  // };

  return (
    <StyledDiv>
      <Row justify="space-between" className="pageDropdown">
        <Dropdown menu={{ items: userGuideMenuItems }}>
          <a href="/#" onClick={(e) => e.preventDefault()}>
            도움말 <DownOutlined rev={undefined} />
          </a>
        </Dropdown>
        <Dropdown menu={{ items: serviceMenuItems }} className="serviceMenu">
          <a href="/#" onClick={(e) => e.preventDefault()}>
            서비스 <DownOutlined rev={undefined} />
          </a>
        </Dropdown>
        <Dropdown menu={{ items: userMenuItems }} className="userMenu">
          <a href="/#" onClick={(e) => e.preventDefault()}>
            {user?.name} <DownOutlined rev={undefined} />
          </a>
        </Dropdown>
      </Row>
    </StyledDiv>
  );
}

export default PageDropdown;
